import React from 'react';

/**
 * SafeLabel - Drop-in replacement for react-aria-components Label
 * Prevents crashes when Label is used outside required parent components
 */
export function SafeLabel({ htmlFor, className, children, ...rest }) {
  return (
    <label htmlFor={htmlFor} className={className} {...rest}>
      {children}
    </label>
  );
}

export default SafeLabel;